<template>  
  <div class="salesmanOrderDeliveryPage">
    <XR-head titleText="订单发货"></XR-head>
    <div class="form">
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
           <mu-select-field fullWidth  label="物流公司" v-model="deliveryInfo.LogisticsCompanyId" helpText="请选择物流公司">
            <mu-menu-item value="" title="选择物流公司" />
            <mu-menu-item :value="lItem.Id" :title="lItem.Name" v-for="lItem in logisticsList" :key="lItem.Id"/>
          </mu-select-field>
        </mu-col>
      </mu-row>  
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="33">
          <mu-text-field label="物流单号" helpText="用户可根据此单号追踪物流信息" v-model="deliveryInfo.DeliveryNo" labelFloat fullWidth />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="33">
          <mu-text-field label="联系人" helpText="用户可与联系人咨询" v-model="deliveryInfo.Name" labelFloat fullWidth />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="33">
          <mu-text-field label="联系电话" helpText="用户可与联系人咨询" v-model="deliveryInfo.Phone" labelFloat fullWidth />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="33">
          <mu-text-field label="发货地址" helpText="发货人的地址" v-model="deliveryInfo.Address" labelFloat fullWidth />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="33">
          <mu-text-field label="收货人信息" helpText="收货人信息" v-model="receiverInfo.Receiver + ' ' + receiverInfo.Phone + ' ' +receiverInfo.Address" labelFloat fullWidth />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="orderDelivery()" />
        </mu-col>
      </mu-row>  
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deliveryInfo: {
        OrderNo: this.$route.query.orderNo,
        LogisticsCompanyId: 0,
        DeliveryNo: '',
        Name: '',
        Phone: '',
        Address: ''
      },      
      logisticsList:[],
      receiverInfo:{}
    };
  },
  mounted() {
    this.getLogisticsList()
    this.GetReceiverInfo()
  },
  methods: {
    orderDelivery() {
      var ths = this;
      ths
        .$post(
          "/Salesman/RetailServer/OrderDelivery", this.deliveryInfo
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.$refs.XRtoast.success(res.Msg, true);
          }
        });
    },
    getLogisticsList(){      
      var ths = this;
      ths
        .$post(
          "/Salesman/RetailServer/GetLogisticsList", this.evaluateInfo
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.logisticsList = res.Data
          }
        });
    },
    GetReceiverInfo(){      
      var ths = this;
      ths
        .$post(
          "/Salesman/RetailServer/GetDeliveryInfo", {orderNo : this.deliveryInfo.OrderNo}
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.receiverInfo = res.Data
          }
        });
    },
    goBack() {
      this.$router.goBack();
    },
    stars: function(index) {
      this.evaluateInfo.StarLevel = index + 1;
    }
  }
};
</script>

<style>
body .salesmanOrderDeliveryPage{
  background: white;
}
.salesmanOrderDeliveryPage .form {
  background: white;
  padding: 10px;
}
.salesmanOrderDeliveryPage .remark {
  background: white;
}
.salesmanOrderDeliveryPage .button-row {
  padding: 40px 20px 0 20px;
}
.salesmanOrderDeliveryPage .submit {
  height: 50px;
}

.salesmanOrderDeliveryPage .evaStar {
  padding: 30px 0;
  text-align: center;
}
.salesmanOrderDeliveryPage .evaStar .star-item {
  font-size: 12px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  padding: 3px;
  margin: 0;
  color:#ccc;
}
.salesmanOrderDeliveryPage .evaStar .star-item.on{
  color:red;
}
.salesmanOrderDeliveryPage .btn-div {
  padding: 40px 5% 30px;
}
.salesmanOrderDeliveryPage .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/delivery.vue